import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import "./Scientific.css";
import Typewriter from "../Utils/Typewriter/Typewriter";

export default function Scientific({ displayRoute }) {
  const { name } = useParams();

  const [drawerOpen, setDrawerOpen] = useState(false);
  const [imageNumber, setImageNumber] = useState(1);
  const [texts, setTexts] = useState(["Scientific Program Details Coming Soon."]);

  useEffect(() => {
    // componentDidMount
  }, []);

  return (
    <div className="screen-container">
      <div className="home-page-text">
        <div style={{ textAlign: "center" }}>
          <div className="chatbox-bg">
            <img src="/loader-card.png" alt="Chatbox Background" />

            <div className="page-text">
              <Typewriter texts={texts} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
